import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { RegisterComponent } from './pages/register/register.component';
import { SignatureComponent } from './pages/signature/signature.component';
import { SignerSuccessComponent } from './pages/signer-success/signer-success.component';
import { SignerErrorComponent } from './pages/signer-error/signer-error.component';

const routes: Routes = [
  {
    path: '', 
    component: HomeComponent,
  },
  {
    path: 'signature', 
    component: SignatureComponent,
  },
  {
    path: 'register', 
    component: RegisterComponent,
  },
  {
    path: 'document/:uidDoc/signer/:uidSigner', 
    component: SignatureComponent
  },
  {
    path: 'subscription-success',
    component: SignerSuccessComponent
  },
  //Wild Card Route for 404 request
  { 
    path: 'page-not-found',
    component: SignerErrorComponent 
  }
  /*{
    path: '**', 
    redirectTo: '/page-not-found'
  }*/
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
